/** labd, The Dev Labs learning assistant. Copy follows its public VS Code Marketplace listing. */

export interface LabdLink {
  label: string;
  href: string;
}

/** One of the three places labd runs. */
export interface LabdDoor {
  id: "vscode" | "terminal" | "portal";
  kicker: string;
  title: string;
  line: string;
  link?: LabdLink;
  command?: string;
}

export interface LabdMode {
  name: "ask" | "auto" | "agent";
  line: string;
}

export const LABD_MARKETPLACE_URL =
  "https://marketplace.visualstudio.com/items?itemName=thedevlabs-io.labd";
export const LABD_INSTALL_COMMAND = "npm i -g @thedevlabs-io/labd";
const LABD_PORTAL_URL = "https://learn.thedevlabs.io";

export const LABD_DOORS: readonly LabdDoor[] = [
  {
    id: "vscode",
    kicker: "VS Code extension",
    title: "In your editor",
    line: "Opens in the side bar next to your code. Explains the open file, the errors the editor is reporting, and how to improve what you've selected. Ask anything with ⌘⌥L (Ctrl+Alt+L).",
    link: { label: "Install it from the Marketplace ↗", href: LABD_MARKETPLACE_URL },
  },
  {
    id: "terminal",
    kicker: "Terminal agent",
    title: "In your terminal",
    line: "Run labd in any project for a session, or labd -p for a single answer you can pipe into scripts. Needs Node 22 or newer.",
    command: LABD_INSTALL_COMMAND,
  },
  {
    id: "portal",
    kicker: "Learning portal",
    title: "Beside every lesson",
    line: "Docked on every page of learn.thedevlabs.io. It knows the lesson you're on, and on anything graded it coaches instead of handing over the answer.",
    link: { label: "Open learn.thedevlabs.io ↗", href: LABD_PORTAL_URL },
  },
];

export const LABD_ABILITIES: readonly string[] = [
  "Explains the file you're on: what it's for and what a newcomer would trip over.",
  "Walks through the errors your editor reports: what they mean, what caused them, how to fix them.",
  "Reads other files and searches your workspace when the answer needs more context.",
  "Edits files when a change is the answer, and every turn that changes files has a put back control that reverts it in one go.",
  "Runs your tests or build when it's better to look than to guess.",
  "Remembers what you're building, across the editor, the terminal and the portal.",
];

export const LABD_MODES: readonly LabdMode[] = [
  { name: "ask", line: "Asks before it edits a file or runs a command." },
  { name: "auto", line: "Edits on its own, asks before running a command. The default." },
  { name: "agent", line: "Edits and runs commands on its own." },
];

/** Install is free; use needs an account and draws on a monthly allowance. */
export const LABD_ACCESS_NOTE =
  "Free to install. Sign in with a free Dev Labs account; answers come from a monthly allowance.";

export const LABD_GUARDRAIL =
  "In every mode it refuses sudo, deploys, publishing, pushing a branch and reading credential files.";
